export default __webpack_public_path__ + "static/media/GT-America-Regular.c4d29509.woff";